
<span class="success-snackbar" matSnackBarLabel>
  {{ snackBarRef.containerInstance.snackBarConfig.data.message }}
</span>
<span class="action" matSnackBarActions>
  <button class="success-snackbar" mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">
    {{ snackBarRef.containerInstance.snackBarConfig.data.action }}
  </button>
</span>
